import React, {useState} from 'react'
import GenericModal from "../../../../components/modal/GenericModal";
import {
  registrarTerminoLicenciaCondicionAPI
} from "../../../../consumers/backendApisUrls";
import {Div} from "../components/Components";
import InputDate from "../../../../components/modalComponents/InputDate";
import InputUploadFile from "../../../../components/modalComponents/InputUploadFile";
import InputTextArea from "../../../../components/modalComponents/InputTextArea";
import {usePropsInputs} from "../../../../hooks/useProps/usePropsInput";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";

const KEYS = Object.freeze({
  idCondicion: "IdCondicion",
  ComentarioTermino: "ComentarioTermino",
  SustentoFileTermino: "SustentoFileTermino",
  fechaFinCondicion: "FechaFinCondicion",
});

const SECTION_NAME = "TerminarLicencia";

const TerminarLicencia = ({ toggleModal,  IdCondicion, toggleMainModal, refreshMainPage, fechaInicioCondicion, fechaFinCondicion }) => {
  const [formValues, setFormValues] = useState({});
  const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
  const [isUploading, setIsUploading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitForm] = useSubmitForm();

  const handleSubmit = async (e) => {
    e && e.preventDefault();
    setIsSubmitting(true);
    const api = registrarTerminoLicenciaCondicionAPI();
    const payload = {
      IdCondicion: IdCondicion,
      ...formValues
    }

    try {
      await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, sucessterminarCondicionCallBack);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  }

  const sucessterminarCondicionCallBack = () => {
    toggleModal();
    toggleMainModal();
    refreshMainPage();
  }



  const fechaFinAsDate = new Date(fechaFinCondicion);
  fechaFinAsDate.setDate(fechaFinAsDate.getDate() - 1);
  const fechaFinMenos1DiaString = fechaFinAsDate.toISOString().slice(0, 10);

  const fechaInicioAsDate = new Date(fechaInicioCondicion);
  //fechaInicioAsDate.setDate(fechaInicioAsDate.getDate() + 1);
  const fechaInicioMas1DiaString = fechaInicioAsDate.toISOString().slice(0, 10);


  return (
    <GenericModal
      titulo="Confirmar Terminar Licencia"
      showModal={toggleModal}
      width={"600px"}
      saveButtonDisabled={isUploading || isSubmitting}
      isSubmitting={isSubmitting}
    >
      <div className="modal-body pt-0 pl-0">
        <Div col={12}>
          <InputDate
              label={"Fecha de fin"}
              name={KEYS.fechaFinCondicion}
              sectionName={SECTION_NAME}
              isDisabled={formValues.isDisabled}
              min={fechaInicioMas1DiaString}
              max={fechaFinMenos1DiaString}
              {...commonProps(KEYS.fechaFinCondicion)}
          />
        </Div>
        <Div col={12}>
          <InputUploadFile
              label="Sustento"
              name={KEYS.SustentoFileTermino}
              uploadFile={formValues[KEYS.SustentoFileTermino]}
              sectionName={SECTION_NAME}
              setIsUploading={setIsUploading}
              validExtensions={["pdf", "jpg", "png"]}
              isDisabled={formValues.isDisabled}
              setUploadFile={(res) => setFormValues({ ...formValues, [KEYS.SustentoFileTermino]: res })}
          />
        </Div>
        <Div col={12}>
          <InputTextArea
              label="Comentario"
              direction="column"
              sectionName={SECTION_NAME}
              isDisabled={formValues.isDisabled}
              {...commonProps(KEYS.ComentarioTermino)}
          />
        </Div>
      </div>
      <div className="modal-footer justify-content-end">
        <button
            className="btn btn-outline-primary generic-button-ficha-outlined mr-2"
            onClick={() => { toggleModal() }}>
          Cancelar
        </button>
        <button
          className="btn btn-primary generic-button-ficha mr-2"
          onClick={handleSubmit}>
          Terminar
        </button>
      </div>
    </GenericModal>
  )
}

export default TerminarLicencia